import React, { useState, useEffect } from 'react'
import { Button, Col, Modal, Input } from 'reactstrap'
import { HeaderModal } from '../Basicos'

const ModalAtualizarAula = ({ isOpen, fecharModal, atualizarAula, alocacoes = [] }) => {
    const [aulasSelecionadas, setAulasSelecionadas] = useState([]);

    useEffect(() => {
        if (isOpen) {
            setAulasSelecionadas([]);
        }
    }, [isOpen]);

    const handleSalvar = (atualizaHoje) => {
        atualizarAula(atualizaHoje, false, aulasSelecionadas);
    };

    const handleSelecionarAula = (horarioAulaId) => {
        setAulasSelecionadas(prev => {
            if (prev.includes(horarioAulaId)) {
                return prev.filter(id => id !== horarioAulaId);
            } else {
                return [...prev, horarioAulaId];
            }
        });
    };

    const handleSelecionarTodas = () => {
        if (aulasSelecionadas.length === alocacoes.length) {
            setAulasSelecionadas([]);
        } else {
            setAulasSelecionadas(alocacoes.map(aloc => aloc.horario_aula_id));
        }
    };

    const formatarData = (dataStr) => {
        if (!dataStr) return '';
        const partes = dataStr.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return dataStr;
    };

    const formatarHorario = (inicio, fim) => {
        if (!inicio) return '';
        const extrairHoraMinuto = (tempo) => {
            if (!tempo) return '';
            const partes = tempo.split(':');
            if (partes.length >= 2) return `${partes[0]}:${partes[1]}`;
            return tempo;
        };
        const inicioFormatado = extrairHoraMinuto(inicio);
        const fimFormatado = extrairHoraMinuto(fim);
        if (inicioFormatado && fimFormatado) {
            return ` às ${inicioFormatado} - ${fimFormatado}`;
        }
        if (inicioFormatado) {
            return ` às ${inicioFormatado}`;
        }
        return '';
    };

    return (
        <>
            <style>{`
                .modal-atualizar-aula-custom {
                    max-width: 650px !important;
                    width: 650px !important;
                }
                .modal-atualizar-aula-custom .modal-content {
                    border-radius: 8px !important;
                    border: none !important;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15) !important;
                }
                .aula-card-checkbox {
                    width: 18px !important;
                    height: 18px !important;
                    margin: 0 12px 0 0 !important;
                    cursor: pointer !important;
                    position: static !important;
                    opacity: 1 !important;
                }
                .aula-card-item {
                    font-size: 0.85rem;
                    padding: 12px 14px;
                    margin-bottom: 8px;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    color: var(--cor-text-principal);
                    cursor: pointer;
                    transition: all 0.2s ease-in-out;
                }
            `}</style>

            <Modal isOpen={isOpen} className="modal-atualizar-aula-custom" size="md" centered>
                <HeaderModal
                    icon={false}
                    titulo={'Salvar Alterações'}
                    toggle={fecharModal}
                    sm={12}
                    colClassName="modalConsulta__menu atualizar-aula"
                />
                <Col sm={12} style={{ padding: '20px 30px' }}>
                    {alocacoes && alocacoes.length > 0 && (
                        <div style={{ marginBottom: '16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <div style={{ fontSize: '0.85rem', fontWeight: '600', color: 'var(--cor-text-secundario)', textAlign: 'left' }}>
                                    Aulas alocadas encontradas:
                                </div>
                                {alocacoes.length > 1 && (
                                    <div style={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleSelecionarTodas}>
                                        <input 
                                            type="checkbox" 
                                            className="aula-card-checkbox"
                                            checked={aulasSelecionadas.length === alocacoes.length && alocacoes.length > 0}
                                            onChange={handleSelecionarTodas}
                                        />
                                        <label style={{ margin: 0, cursor: 'pointer', fontWeight: '600', color: 'var(--cor-text-secundario)' }}>
                                            Selecionar todas
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div style={{
                                maxHeight: '280px',
                                overflowY: 'auto',
                                padding: '4px'
                            }}>
                                {alocacoes.map((aloc, idx) => {
                                    const estaSelecionada = aulasSelecionadas.includes(aloc.horario_aula_id);
                                    return (
                                        <div 
                                            key={idx} 
                                            onClick={() => handleSelecionarAula(aloc.horario_aula_id)}
                                            className="aula-card-item"
                                            style={{
                                                border: estaSelecionada ? '1.5px solid #0056b3' : '1px solid #e9ecef',
                                                backgroundColor: estaSelecionada ? '#f0f7ff' : '#ffffff'
                                            }}
                                        >
                                            <input 
                                                type="checkbox" 
                                                className="aula-card-checkbox"
                                                checked={estaSelecionada}
                                                onChange={() => handleSelecionarAula(aloc.horario_aula_id)}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span><strong>Turma:</strong> {aloc.turma_descricao || 'Todos'}</span>
                                                    <span style={{ color: 'var(--cor-text-secundario)', fontWeight: '500' }}>
                                                        {formatarData(aloc.data)}{formatarHorario(aloc.horario_inicio, aloc.horario_fim)}
                                                    </span>
                                                </div>
                                                <div style={{ color: 'var(--cor-text-secundario)', marginTop: '4px', fontSize: '0.8rem' }}>
                                                    {aloc.periodo_descricao} {aloc.periodo_vigente ? '(Vigente)' : ''}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    
                    {(!alocacoes || alocacoes.length === 0) && (
                        <div style={{ fontSize: '0.85rem', color: 'var(--cor-text-secundario)', textAlign: 'center', padding: '16px 0' }}>
                            Nenhuma aula alocada encontrada.
                        </div>
                    )}

                    <div style={{ marginTop: '20px', fontSize: '0.9rem', color: 'var(--cor-text-secundario)', textAlign: 'center' }}>
                        {alocacoes && alocacoes.length > 0 
                            ? 'Selecione acima as aulas que deseja atualizar e confirme.' 
                            : 'Não há aulas para atualizar o conteúdo/professor na grade, deseja apenas salvar a aula base?'}
                    </div>
                </Col>

                <Col sm={12} className="align-content-middle mb-3 p-0" style={{ padding: '8px 30px 20px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
                    <Button onClick={() => fecharModal()} className="btn-transparente">
                        Cancelar
                    </Button>
                    <Button onClick={() => handleSalvar(true)} className="">
                        {aulasSelecionadas.length > 0 ? 'Salvar e atualizar aulas selecionadas' : 'Salvar e não atualizar aulas acima'}
                    </Button>
                </Col>
            </Modal>
        </>
    )
}

export default ModalAtualizarAula